// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Meci Professional Theme - Blood Red & Slate */
  --bg-primary: #0f172a;        /* Deep Navy (Unified) */
  --bg-secondary: #0f172a;      /* Unified */
  --bg-tertiary: #0f172a;       /* Unified */
  --bg-modifier-hover: rgba(255, 255, 255, 0.04);
  --bg-modifier-active: rgba(255, 255, 255, 0.08);
  --bg-modifier-selected: rgba(153, 27, 27, 0.12);
  --bg-floating: #0f172a;
  
  --text-primary: #f8fafc;      /* Slate 50 */
  --text-secondary: #94a3b8;    /* Slate 400 */
  --text-muted: #64748b;        /* Slate 500 */
  --text-link: #f87171;         /* Light Red */
  --text-bright: #ffffff;
  
  --brand-primary: #991b1b;     /* Blood Red */
  --brand-hover: #b91c1c;       /* Brighter Red */
  --brand-active: #7f1d1d;      /* Darker Red */
  --brand-light: #ef4444;       
  
  --status-online: #10b981;
  --status-idle: #f59e0b;
  --status-dnd: #ef4444;
  --status-offline: #64748b;
  
  --danger: #991b1b;
  --danger-hover: #7f1d1d;
  --warning: #f59e0b;
  --success: #10b981;
  --info: #3b82f6;
  
  --channel-text: #94a3b8;
  --channel-hover: #f8fafc;
  --channel-selected: #ffffff;
  
  --scrollbar-thumb: rgba(153, 27, 27, 0.2);
  --scrollbar-track: transparent;
  
  --input-bg: rgba(2, 6, 23, 0.5);
  --input-border: rgba(153, 27, 27, 0.2);
  
  --header-height: 60px;
  --sidebar-width: 280px;
  --server-list-width: 80px;
  
  /* Glassmorphism */
  --glass-bg: rgba(15, 23, 42, 0.7);
  --glass-border: rgba(255, 255, 255, 0.05);
  --glass-blur: blur(20px);
  
  /* Enhanced Transitions */
  --transition-fast: 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  --transition-normal: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  
  /* Border Radius */
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 20px;
  --radius-xl: 32px;
  --radius-full: 50%;
  
  /* Shadows */
  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.2);
  --shadow-lg: 0 12px 24px rgba(0, 0, 0, 0.3);
  --shadow-xl: 0 20px 40px rgba(0, 0, 0, 0.5);
  
  /* Gradients */
  --gradient-brand: linear-gradient(135deg, #991b1b, #7f1d1d);
  --gradient-dark: linear-gradient(to bottom, rgba(2, 6, 23, 0.8), rgba(2, 6, 23, 1));
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2)) transparent;
}

body {
  font-family: 'Inter', 'Outfit', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Cohesive Unified Theme Scrollbars */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2));
  border-radius: 10px;
  transition: all 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary);
}

/* Global Container Scrollbar Behavior */
.scrollable {
  overflow-y: auto;
  scrollbar-gutter: stable;
}

.scrollable::-webkit-scrollbar-thumb {
  background: rgba(153, 27, 27, 0.1);
}

.scrollable:hover::-webkit-scrollbar-thumb {
  background: rgba(153, 27, 27, 0.3);
}

/* Selection */
::selection {
  background-color: var(--brand-primary);
  color: white;
}

/* Typography Refinements */
h1, h2, h3, h4, h5, h6 {
  letter-spacing: -0.02em;
}

/* Interactive Elements */
button {
  font-family: inherit;
  outline: none;
}

/* Layout Classes */
.glass-container {
  background: var(--glass-bg);
  backdrop-filter: var(--glass-blur);
  border: 1px solid var(--glass-border);
}

/* Premium Animations */
@keyframes entrance {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.animate-entrance {
  animation: entrance var(--transition-slow) forwards;
}

@keyframes pulse-glow {
  0% { box-shadow: 0 0 0 0 rgba(153, 27, 27, 0.4); }
  70% { box-shadow: 0 0 0 15px rgba(153, 27, 27, 0); }
  100% { box-shadow: 0 0 0 0 rgba(153, 27, 27, 0); }
}

.glow-effect {
  animation: pulse-glow 2s infinite;
}

/* --- THEMES --- */

/* Discord Classic Theme */
[data-theme="discord-classic"] {
  --bg-primary: #313338;
  --bg-secondary: #2b2d31;
  --bg-tertiary: #1e1f22;
  --bg-modifier-hover: rgba(255, 255, 255, 0.06);
  --bg-modifier-active: rgba(255, 255, 255, 0.1);
  --bg-modifier-selected: rgba(88, 101, 242, 0.15);
  --bg-floating: #232428;
  
  --text-primary: #f2f3f5;
  --text-secondary: #b5bac1;
  --text-muted: #949ba4;
  --text-link: #00a8fc;
  
  --brand-primary: #5865f2;
  --brand-hover: #4752c4;
  --brand-active: #3c45a5;
  --brand-light: #5865f2;
  
  --scrollbar-thumb: rgba(88, 101, 242, 0.2);
  --input-bg: #383a40;
  --input-border: #1e1f22;
  
  --glass-bg: rgba(43, 45, 49, 0.8);
  --glass-border: rgba(255, 255, 255, 0.05);
  
  --gradient-brand: linear-gradient(135deg, #5865f2, #4752c4);
}

/* Cyberpunk Titanium Stealth Theme - Çizgisiz, Saf Titanyum Gri & Obsidyen Mat */
[data-theme="cyberpunk"] {
  --bg-primary: #08090d;
  --bg-secondary: #0c0e14;
  --bg-tertiary: #040507;
  --bg-modifier-hover: rgba(148, 163, 184, 0.06);
  --bg-modifier-active: rgba(148, 163, 184, 0.12);
  --bg-modifier-selected: rgba(148, 163, 184, 0.16);
  --bg-floating: #10121a;
  
  --text-primary: #f8fafc;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;
  --text-link: #cbd5e1;
  --text-bright: #ffffff;
  
  --brand-primary: #475569;
  --brand-hover: #64748b;
  --brand-active: #334155;
  --brand-light: #94a3b8;
  
  --scrollbar-thumb: rgba(148, 163, 184, 0.15);
  --input-bg: #10121a;
  --input-border: transparent;
  
  --glass-bg: rgba(12, 14, 20, 0.95);
  --glass-border: transparent;
  
  --gradient-brand: linear-gradient(135deg, #334155, #1e293b);
  --gradient-dark: linear-gradient(to bottom, #0c0e14, #08090d);
  box-shadow: none !important;
}

/* Cyberpunk Modern Modular Workspace (Farklı, Lüks ve Ergonomik Ada Mimarisi) */
[data-theme="cyberpunk"] .app {
  background: #040507 !important;
}

[data-theme="cyberpunk"] .app-container {
  background: #040507 !important;
  padding: 8px 10px 10px 0 !important;
  gap: 8px !important;
}

[data-theme="cyberpunk"] .server-list {
  background: transparent !important;
  padding-top: 8px !important;
}

[data-theme="cyberpunk"] .channel-sidebar {
  background: #0c0e14 !important;
  border-radius: 18px !important;
  overflow: hidden !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;
}

[data-theme="cyberpunk"] .main-content {
  background: #08090d !important;
  border-radius: 18px !important;
  overflow: hidden !important;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.5) !important;
}

[data-theme="cyberpunk"] .member-list-panel {
  background: #0c0e14 !important;
  border-radius: 18px !important;
  margin-left: 8px !important;
  overflow: hidden !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;
}

/* Cyberpunk Sıfır Çizgi & Dikişsiz Görünüm (Zero Lines / Seamless Panels) */
[data-theme="cyberpunk"] * {
  border-color: transparent !important;
}

[data-theme="cyberpunk"] .channel-sidebar,
[data-theme="cyberpunk"] .server-list,
[data-theme="cyberpunk"] .member-list-panel,
[data-theme="cyberpunk"] .member-list-header,
[data-theme="cyberpunk"] .chat-header,
[data-theme="cyberpunk"] .titlebar,
[data-theme="cyberpunk"] .title-bar,
[data-theme="cyberpunk"] .channel-footer,
[data-theme="cyberpunk"] .channel-header,
[data-theme="cyberpunk"] .user-panel,
[data-theme="cyberpunk"] .voice-connection-card,
[data-theme="cyberpunk"] .control-pill,
[data-theme="cyberpunk"] .message-actions-bar,
[data-theme="cyberpunk"] .message-input-area,
[data-theme="cyberpunk"] .message-input-control,
[data-theme="cyberpunk"] .channel-info-pill,
[data-theme="cyberpunk"] .discord-embed,
[data-theme="cyberpunk"] .user-profile-panel,
[data-theme="cyberpunk"] .settings-container,
[data-theme="cyberpunk"] .settings-sidebar,
[data-theme="cyberpunk"] .settings-content,
[data-theme="cyberpunk"] .message-reply-context,
[data-theme="cyberpunk"] .action-divider {
  border: none !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  border-bottom: none !important;
  outline: none !important;
}

[data-theme="cyberpunk"] .action-divider {
  display: none !important;
}

[data-theme="cyberpunk"] .main-content::before,
[data-theme="cyberpunk"] .chat-header::after,
[data-theme="cyberpunk"] .channel-sidebar::after,
[data-theme="cyberpunk"] .app::before {
  display: none !important;
}

/* Cyberpunk Aktif İkon ve Vurgular - Pembe/Mor Tamamen Sıfırlandı, Saf Titanyum Gri */
[data-theme="cyberpunk"] .server-icon {
  border-radius: 16px !important;
  border: none !important;
}

[data-theme="cyberpunk"] .server-icon.active {
  background-color: #1e293b !important;
  color: #f8fafc !important;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.5) !important;
  border-radius: 16px !important;
}

[data-theme="cyberpunk"] .server-icon.active .server-icon-inner {
  background: #1e293b !important;
  color: #f8fafc !important;
  border-radius: 16px !important;
}

[data-theme="cyberpunk"] .active-indicator {
  background-color: #cbd5e1 !important;
  box-shadow: 0 0 10px rgba(203, 213, 225, 0.4) !important;
  border-radius: 4px !important;
}

[data-theme="cyberpunk"] .channel-item {
  border-radius: 10px !important;
  margin: 3px 10px !important;
  padding: 8px 14px !important;
  border: none !important;
  color: #94a3b8 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

[data-theme="cyberpunk"] .channel-item:hover {
  background: rgba(255, 255, 255, 0.04) !important;
  color: #f8fafc !important;
}

[data-theme="cyberpunk"] .channel-item.selected {
  background: rgba(255, 255, 255, 0.08) !important;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25) !important;
}

[data-theme="cyberpunk"] .channel-icon {
  color: #64748b !important;
  filter: none !important;
  transition: color 0.2s ease !important;
}

[data-theme="cyberpunk"] .channel-item:hover .channel-icon {
  color: #94a3b8 !important;
}

[data-theme="cyberpunk"] .channel-item.selected .channel-icon {
  color: #cbd5e1 !important;
}

[data-theme="cyberpunk"] .category-header,
[data-theme="cyberpunk"] .category-name {
  color: #64748b !important;
}

/* Header & Search Bar */
[data-theme="cyberpunk"] .chat-header {
  background: #08090d !important;
}

[data-theme="cyberpunk"] .chat-header .channel-icon {
  color: #94a3b8 !important;
  filter: none !important;
}

[data-theme="cyberpunk"] .channel-info-pill {
  background: rgba(255, 255, 255, 0.03) !important;
  border: none !important;
}

[data-theme="cyberpunk"] .channel-info-pill:hover {
  background: rgba(255, 255, 255, 0.06) !important;
  border: none !important;
}

[data-theme="cyberpunk"] .header-icon-btn,
[data-theme="cyberpunk"] .upload-btn,
[data-theme="cyberpunk"] .control-btn,
[data-theme="cyberpunk"] .control-btn.active,
[data-theme="cyberpunk"] .user-panel-btn {
  color: #94a3b8 !important;
  background: transparent !important;
}

[data-theme="cyberpunk"] .header-icon-btn:hover,
[data-theme="cyberpunk"] .control-btn:hover,
[data-theme="cyberpunk"] .upload-btn:hover,
[data-theme="cyberpunk"] .user-panel-btn:hover {
  color: #f8fafc !important;
  background: rgba(255, 255, 255, 0.06) !important;
}

/* Mesaj Giriş Alanı - Yüzen Ada Tasarımı */
[data-theme="cyberpunk"] .message-input-area {
  background: transparent !important;
  padding: 0 20px 20px !important;
}

[data-theme="cyberpunk"] .message-input-control {
  background: #10121a !important;
  border: none !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
  border-radius: 20px !important;
  padding: 6px 14px !important;
}

[data-theme="cyberpunk"] .message-input-control:focus-within {
  border: none !important;
  box-shadow: 0 10px 36px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.08) !important;
}

[data-theme="cyberpunk"] .message-input-field {
  color: #f8fafc !important;
}

[data-theme="cyberpunk"] .send-btn {
  background: #1e293b !important;
  color: #cbd5e1 !important;
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

[data-theme="cyberpunk"] .send-btn:hover {
  background: #334155 !important;
  color: #ffffff !important;
}

/* Nötr Titanyum Avatar Harf Rozetleri (Mor/Pembe Yerine Mat Grafit Gri) */
[data-theme="cyberpunk"] .avatar-inner,
[data-theme="cyberpunk"] .avatar-initial,
[data-theme="cyberpunk"] .avatar-letter,
[data-theme="cyberpunk"] .avatar-placeholder-letter,
[data-theme="cyberpunk"] .preview-avatar-mock {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%) !important;
  color: #cbd5e1 !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
}

/* Üye Listesi & Rozetler */
[data-theme="cyberpunk"] .header-label {
  color: #94a3b8 !important;
}

[data-theme="cyberpunk"] .header-badge {
  background: #334155 !important;
  color: #f8fafc !important;
  box-shadow: none !important;
  border-radius: 8px !important;
}

[data-theme="cyberpunk"] .member-item-professional:hover {
  background: rgba(255, 255, 255, 0.04) !important;
  border-radius: 10px !important;
}

/* TitleBar & Logo */
[data-theme="cyberpunk"] .titlebar {
  background: #040507 !important;
  border: none !important;
}

[data-theme="cyberpunk"] .brand-status {
  background: #334155 !important;
  color: #cbd5e1 !important;
}

[data-theme="cyberpunk"] .m-logo-img {
  filter: none !important;
}

/* Mesajlar, Linkler ve Cevaplar */
[data-theme="cyberpunk"] .message-item:hover {
  background: rgba(255, 255, 255, 0.02) !important;
}

[data-theme="cyberpunk"] .message-author {
  color: #f8fafc !important;
}

[data-theme="cyberpunk"] .message-timestamp {
  color: #64748b !important;
}

[data-theme="cyberpunk"] .message-link-highlight {
  color: #00a8fc !important;
  background: transparent !important;
  border-bottom: none !important;
  text-decoration: none !important;
}

[data-theme="cyberpunk"] .message-link-highlight:hover {
  color: #00a8fc !important;
  background: transparent !important;
  text-decoration: underline !important;
}

[data-theme="cyberpunk"] .message-reply-context {
  background: rgba(255, 255, 255, 0.03) !important;
  border: none !important;
  border-left: 2px solid #475569 !important;
  border-radius: 8px !important;
}

[data-theme="cyberpunk"] .message-reply-accent {
  background: #475569 !important;
}

/* Global Taşma Önleme & Modern Medya Kartları (Anti-Overflow & Sleek Embeds) */
.discord-embed {
  border: none !important;
  border-left: none !important;
  border-radius: 14px !important;
  background: rgba(255, 255, 255, 0.03) !important;
  backdrop-filter: blur(12px) !important;
  padding: 12px 16px !important;
  max-width: 520px !important;
  overflow: hidden !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
}

.embed-image,
.attachment-image-wrapper img,
.discord-embed-thumbnail img {
  max-width: 100% !important;
  max-height: 280px !important;
  object-fit: contain !important;
  border-radius: 10px !important;
  background: #050608 !important;
  display: block !important;
  margin: 0 auto !important;
}

.message-body,
.message-text,
.embed-description,
.embed-title {
  word-break: break-word !important;
  overflow-wrap: anywhere !important;
}

.embed-description a,
.message-text a,
.embed-author-name.link,
.embed-title.link,
.message-link-highlight {
  word-break: break-all !important;
  overflow-wrap: anywhere !important;
  color: #00a8fc !important;
  text-decoration: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.embed-description a:hover,
.message-text a:hover,
.embed-author-name.link:hover,
.embed-title.link:hover,
.message-link-highlight:hover {
  text-decoration: underline !important;
  color: #00a8fc !important;
}

/* Forest Green Theme */
[data-theme="forest"] {
  --bg-primary: #0c1512;
  --bg-secondary: #080f0c;
  --bg-tertiary: #050a08;
  --bg-modifier-hover: rgba(20, 184, 166, 0.08);
  --bg-modifier-active: rgba(20, 184, 166, 0.15);
  --bg-modifier-selected: rgba(15, 118, 110, 0.25);
  --bg-floating: #101f1a;
  
  --text-primary: #f0f7f4;
  --text-secondary: #8ca69e;
  --text-muted: #526e64;
  --text-link: #10b981;
  
  --brand-primary: #0f766e;
  --brand-hover: #0d9488;
  --brand-active: #115e59;
  --brand-light: #14b8a6;
  
  --scrollbar-thumb: rgba(15, 118, 110, 0.3);
  --input-bg: #0d1f1a;
  --input-border: rgba(15, 118, 110, 0.2);
  
  --glass-bg: rgba(12, 21, 18, 0.85);
  --glass-border: rgba(16, 185, 129, 0.08);
  
  --gradient-brand: linear-gradient(135deg, #0f766e, #115e59);
}

/* Light Theme */
[data-theme="light"] {
  --bg-primary: #ffffff;
  --bg-secondary: #f2f3f5;
  --bg-tertiary: #e3e5e8;
  --bg-modifier-hover: rgba(0, 0, 0, 0.05);
  --bg-modifier-active: rgba(0, 0, 0, 0.1);
  --bg-modifier-selected: rgba(88, 101, 242, 0.15);
  --bg-floating: #ffffff;
  
  --text-primary: #060607;
  --text-secondary: #4e5058;
  --text-muted: #6d6f78;
  --text-link: #0068e0;
  --text-bright: #000000;
  
  --brand-primary: #5865f2;
  --brand-hover: #4752c4;
  --brand-active: #3c45a5;
  --brand-light: #5865f2;
  
  --scrollbar-thumb: rgba(88, 101, 242, 0.2);
  --input-bg: #e3e5e8;
  --input-border: rgba(0,0,0,0.1);
  
  --glass-bg: rgba(242, 243, 245, 0.9);
  --glass-border: rgba(0, 0, 0, 0.08);
  
  --gradient-brand: linear-gradient(135deg, #5865f2, #4752c4);
}

/* Amber Gold / Sarı & Siyah Tema - Mat Siyah ve Amber Sarısı Vurgular */
[data-theme="amber-gold"] {
  --bg-primary: #0a0b0e;
  --bg-secondary: #0f1117;
  --bg-tertiary: #060709;
  --bg-modifier-hover: rgba(245, 158, 11, 0.08);
  --bg-modifier-active: rgba(245, 158, 11, 0.14);
  --bg-modifier-selected: rgba(245, 158, 11, 0.2);
  --bg-floating: #14161f;
  
  --text-primary: #fef3c7;
  --text-secondary: #cbd5e1;
  --text-muted: #78716c;
  --text-link: #f59e0b;
  --text-bright: #ffffff;
  
  --brand-primary: #f59e0b;
  --brand-hover: #fbbf24;
  --brand-active: #d97706;
  --brand-light: #fef08a;
  
  --scrollbar-thumb: rgba(245, 158, 11, 0.25);
  --input-bg: #14161f;
  --input-border: rgba(245, 158, 11, 0.2);
  
  --glass-bg: rgba(15, 17, 23, 0.92);
  --glass-border: rgba(245, 158, 11, 0.1);
  
  --gradient-brand: linear-gradient(135deg, #f59e0b, #d97706);
}

/* Monochrome Noir / Siyah & Beyaz Tema - Ultra Sade, Çizgisiz Saf Kontrast */
[data-theme="monochrome-noir"] {
  --bg-primary: #000000;
  --bg-secondary: #0a0a0a;
  --bg-tertiary: #050505;
  --bg-modifier-hover: rgba(255, 255, 255, 0.06);
  --bg-modifier-active: rgba(255, 255, 255, 0.12);
  --bg-modifier-selected: rgba(255, 255, 255, 0.18);
  --bg-floating: #121212;
  
  --text-primary: #ffffff;
  --text-secondary: #a1a1aa;
  --text-muted: #52525b;
  --text-link: #f4f4f5;
  --text-bright: #ffffff;
  
  --brand-primary: #ffffff;
  --brand-hover: #e4e4e7;
  --brand-active: #d4d4d8;
  --brand-light: #ffffff;
  
  --scrollbar-thumb: rgba(255, 255, 255, 0.15);
  --input-bg: #121212;
  --input-border: rgba(255, 255, 255, 0.15);
  
  --glass-bg: rgba(10, 10, 10, 0.95);
  --glass-border: rgba(255, 255, 255, 0.08);
  
  --gradient-brand: linear-gradient(135deg, #27272a, #09090b);
}

/* Sarı & Beyaz / Warm Ivory Tema - Sıcak Kum ve Bal Rengi Vurgular */
[data-theme="yellow-white"] {
  --bg-primary: #fafaf7;
  --bg-secondary: #f4f3ed;
  --bg-tertiary: #e8e6dc;
  --bg-modifier-hover: rgba(217, 119, 6, 0.08);
  --bg-modifier-active: rgba(217, 119, 6, 0.14);
  --bg-modifier-selected: rgba(217, 119, 6, 0.18);
  --bg-floating: #ffffff;
  
  --text-primary: #1c1917;
  --text-secondary: #57534e;
  --text-muted: #78716c;
  --text-link: #d97706;
  --text-bright: #0c0a09;
  
  --brand-primary: #d97706;
  --brand-hover: #b45309;
  --brand-active: #92400e;
  --brand-light: #f59e0b;
  
  --scrollbar-thumb: rgba(217, 119, 6, 0.25);
  --input-bg: #ffffff;
  --input-border: rgba(217, 119, 6, 0.25);
  
  --glass-bg: rgba(250, 250, 247, 0.94);
  --glass-border: rgba(217, 119, 6, 0.12);
  
  --gradient-brand: linear-gradient(135deg, #d97706, #b45309);
}


/* --- ELECTRON FIXES --- */
input, textarea, select, button {
  -webkit-app-region: no-drag !important;
  -webkit-user-select: text !important;
  user-select: text !important;
}

body {
  -webkit-user-select: auto !important;
  user-select: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,qBAAqB,SAAS,wBAAwB;EACtD,uBAAuB,OAAO,YAAY;EAC1C,sBAAsB,QAAQ,YAAY;EAC1C,8CAA8C;EAC9C,+CAA+C;EAC/C,+CAA+C;EAC/C,sBAAsB;;EAEtB,uBAAuB,OAAO,aAAa;EAC3C,yBAAyB,KAAK,cAAc;EAC5C,qBAAqB,SAAS,cAAc;EAC5C,oBAAoB,UAAU,cAAc;EAC5C,sBAAsB;;EAEtB,wBAAwB,MAAM,cAAc;EAC5C,sBAAsB,QAAQ,iBAAiB;EAC/C,uBAAuB,OAAO,eAAe;EAC7C,sBAAsB;;EAEtB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;;EAEzB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;;EAEf,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;;EAE3B,yCAAyC;EACzC,8BAA8B;;EAE9B,+BAA+B;EAC/B,sCAAsC;;EAEtC,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;;EAEzB,kBAAkB;EAClB,iCAAiC;EACjC,yCAAyC;EACzC,wBAAwB;;EAExB,yBAAyB;EACzB,qDAAqD;EACrD,sDAAsD;EACtD,oDAAoD;;EAEpD,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;;EAElB,YAAY;EACZ,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;;EAE3C,cAAc;EACd,2DAA2D;EAC3D,mFAAmF;AACrF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,qBAAqB;EACrB,6EAA6E;AAC/E;;AAEA;EACE,gFAAgF;EAChF,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,KAAK,0CAA0C,EAAE;EACjD,MAAM,2CAA2C,EAAE;EACnD,OAAO,wCAAwC,EAAE;AACnD;;AAEA;EACE,iCAAiC;AACnC;;AAEA,mBAAmB;;AAEnB,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,8CAA8C;EAC9C,8CAA8C;EAC9C,gDAAgD;EAChD,sBAAsB;;EAEtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;;EAEpB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;;EAEtB,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;;EAEvB,iCAAiC;EACjC,yCAAyC;;EAEzC,2DAA2D;AAC7D;;AAEA,iFAAiF;AACjF;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,8CAA8C;EAC9C,+CAA+C;EAC/C,iDAAiD;EACjD,sBAAsB;;EAEtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;;EAEtB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;;EAEtB,4CAA4C;EAC5C,mBAAmB;EACnB,2BAA2B;;EAE3B,kCAAkC;EAClC,2BAA2B;;EAE3B,2DAA2D;EAC3D,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA,gFAAgF;AAChF;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA,4EAA4E;AAC5E;EACE,oCAAoC;AACtC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;EAuBE,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA,sFAAsF;AACtF;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oDAAoD;EACpD,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;EACxD,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,yBAAyB;EACzB,4DAA4D;AAC9D;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;AACzB;;AAEA;;;;;EAKE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;;;;EAIE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA,2CAA2C;AAC3C;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,oDAAoD;EACpD,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,0FAA0F;AAC5F;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,0EAA0E;AAC1E;;;;;EAKE,wEAAwE;EACxE,yBAAyB;EACzB,sDAAsD;EACtD,oDAAoD;EACpD,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,+EAA+E;AAC/E;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,gDAAgD;EAChD,sCAAsC;EACtC,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;;;EAGE,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;;;;;EAKE,gCAAgC;EAChC,kCAAkC;EAClC,yBAAyB;EACzB,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;;;;EAKE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,6CAA6C;EAC7C,8CAA8C;EAC9C,gDAAgD;EAChD,sBAAsB;;EAEtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;;EAEpB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;;EAEtB,0CAA0C;EAC1C,mBAAmB;EACnB,uCAAuC;;EAEvC,kCAAkC;EAClC,wCAAwC;;EAExC,2DAA2D;AAC7D;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,wCAAwC;EACxC,wCAAwC;EACxC,gDAAgD;EAChD,sBAAsB;;EAEtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;;EAEtB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;;EAEtB,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;;EAE/B,oCAAoC;EACpC,mCAAmC;;EAEnC,2DAA2D;AAC7D;;AAEA,wEAAwE;AACxE;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,6CAA6C;EAC7C,8CAA8C;EAC9C,+CAA+C;EAC/C,sBAAsB;;EAEtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;;EAEtB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;;EAEtB,2CAA2C;EAC3C,mBAAmB;EACnB,uCAAuC;;EAEvC,kCAAkC;EAClC,uCAAuC;;EAEvC,2DAA2D;AAC7D;;AAEA,6EAA6E;AAC7E;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,8CAA8C;EAC9C,+CAA+C;EAC/C,iDAAiD;EACjD,sBAAsB;;EAEtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;;EAEtB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;;EAEtB,4CAA4C;EAC5C,mBAAmB;EACnB,yCAAyC;;EAEzC,kCAAkC;EAClC,yCAAyC;;EAEzC,2DAA2D;AAC7D;;AAEA,qEAAqE;AACrE;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;EAC5C,6CAA6C;EAC7C,+CAA+C;EAC/C,sBAAsB;;EAEtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;;EAEtB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;;EAEtB,0CAA0C;EAC1C,mBAAmB;EACnB,uCAAuC;;EAEvC,qCAAqC;EACrC,uCAAuC;;EAEvC,2DAA2D;AAC7D;;;AAGA,2BAA2B;AAC3B;EACE,sCAAsC;EACtC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B","sourcesContent":[":root {\n  /* Meci Professional Theme - Blood Red & Slate */\n  --bg-primary: #0f172a;        /* Deep Navy (Unified) */\n  --bg-secondary: #0f172a;      /* Unified */\n  --bg-tertiary: #0f172a;       /* Unified */\n  --bg-modifier-hover: rgba(255, 255, 255, 0.04);\n  --bg-modifier-active: rgba(255, 255, 255, 0.08);\n  --bg-modifier-selected: rgba(153, 27, 27, 0.12);\n  --bg-floating: #0f172a;\n  \n  --text-primary: #f8fafc;      /* Slate 50 */\n  --text-secondary: #94a3b8;    /* Slate 400 */\n  --text-muted: #64748b;        /* Slate 500 */\n  --text-link: #f87171;         /* Light Red */\n  --text-bright: #ffffff;\n  \n  --brand-primary: #991b1b;     /* Blood Red */\n  --brand-hover: #b91c1c;       /* Brighter Red */\n  --brand-active: #7f1d1d;      /* Darker Red */\n  --brand-light: #ef4444;       \n  \n  --status-online: #10b981;\n  --status-idle: #f59e0b;\n  --status-dnd: #ef4444;\n  --status-offline: #64748b;\n  \n  --danger: #991b1b;\n  --danger-hover: #7f1d1d;\n  --warning: #f59e0b;\n  --success: #10b981;\n  --info: #3b82f6;\n  \n  --channel-text: #94a3b8;\n  --channel-hover: #f8fafc;\n  --channel-selected: #ffffff;\n  \n  --scrollbar-thumb: rgba(153, 27, 27, 0.2);\n  --scrollbar-track: transparent;\n  \n  --input-bg: rgba(2, 6, 23, 0.5);\n  --input-border: rgba(153, 27, 27, 0.2);\n  \n  --header-height: 60px;\n  --sidebar-width: 280px;\n  --server-list-width: 80px;\n  \n  /* Glassmorphism */\n  --glass-bg: rgba(15, 23, 42, 0.7);\n  --glass-border: rgba(255, 255, 255, 0.05);\n  --glass-blur: blur(20px);\n  \n  /* Enhanced Transitions */\n  --transition-fast: 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-normal: 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  \n  /* Border Radius */\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 20px;\n  --radius-xl: 32px;\n  --radius-full: 50%;\n  \n  /* Shadows */\n  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.2);\n  --shadow-lg: 0 12px 24px rgba(0, 0, 0, 0.3);\n  --shadow-xl: 0 20px 40px rgba(0, 0, 0, 0.5);\n  \n  /* Gradients */\n  --gradient-brand: linear-gradient(135deg, #991b1b, #7f1d1d);\n  --gradient-dark: linear-gradient(to bottom, rgba(2, 6, 23, 0.8), rgba(2, 6, 23, 1));\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2)) transparent;\n}\n\nbody {\n  font-family: 'Inter', 'Outfit', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  overflow: hidden;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Cohesive Unified Theme Scrollbars */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2));\n  border-radius: 10px;\n  transition: all 0.3s;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--brand-primary);\n}\n\n/* Global Container Scrollbar Behavior */\n.scrollable {\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n}\n\n.scrollable::-webkit-scrollbar-thumb {\n  background: rgba(153, 27, 27, 0.1);\n}\n\n.scrollable:hover::-webkit-scrollbar-thumb {\n  background: rgba(153, 27, 27, 0.3);\n}\n\n/* Selection */\n::selection {\n  background-color: var(--brand-primary);\n  color: white;\n}\n\n/* Typography Refinements */\nh1, h2, h3, h4, h5, h6 {\n  letter-spacing: -0.02em;\n}\n\n/* Interactive Elements */\nbutton {\n  font-family: inherit;\n  outline: none;\n}\n\n/* Layout Classes */\n.glass-container {\n  background: var(--glass-bg);\n  backdrop-filter: var(--glass-blur);\n  border: 1px solid var(--glass-border);\n}\n\n/* Premium Animations */\n@keyframes entrance {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.animate-entrance {\n  animation: entrance var(--transition-slow) forwards;\n}\n\n@keyframes pulse-glow {\n  0% { box-shadow: 0 0 0 0 rgba(153, 27, 27, 0.4); }\n  70% { box-shadow: 0 0 0 15px rgba(153, 27, 27, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(153, 27, 27, 0); }\n}\n\n.glow-effect {\n  animation: pulse-glow 2s infinite;\n}\n\n/* --- THEMES --- */\n\n/* Discord Classic Theme */\n[data-theme=\"discord-classic\"] {\n  --bg-primary: #313338;\n  --bg-secondary: #2b2d31;\n  --bg-tertiary: #1e1f22;\n  --bg-modifier-hover: rgba(255, 255, 255, 0.06);\n  --bg-modifier-active: rgba(255, 255, 255, 0.1);\n  --bg-modifier-selected: rgba(88, 101, 242, 0.15);\n  --bg-floating: #232428;\n  \n  --text-primary: #f2f3f5;\n  --text-secondary: #b5bac1;\n  --text-muted: #949ba4;\n  --text-link: #00a8fc;\n  \n  --brand-primary: #5865f2;\n  --brand-hover: #4752c4;\n  --brand-active: #3c45a5;\n  --brand-light: #5865f2;\n  \n  --scrollbar-thumb: rgba(88, 101, 242, 0.2);\n  --input-bg: #383a40;\n  --input-border: #1e1f22;\n  \n  --glass-bg: rgba(43, 45, 49, 0.8);\n  --glass-border: rgba(255, 255, 255, 0.05);\n  \n  --gradient-brand: linear-gradient(135deg, #5865f2, #4752c4);\n}\n\n/* Cyberpunk Titanium Stealth Theme - Çizgisiz, Saf Titanyum Gri & Obsidyen Mat */\n[data-theme=\"cyberpunk\"] {\n  --bg-primary: #08090d;\n  --bg-secondary: #0c0e14;\n  --bg-tertiary: #040507;\n  --bg-modifier-hover: rgba(148, 163, 184, 0.06);\n  --bg-modifier-active: rgba(148, 163, 184, 0.12);\n  --bg-modifier-selected: rgba(148, 163, 184, 0.16);\n  --bg-floating: #10121a;\n  \n  --text-primary: #f8fafc;\n  --text-secondary: #94a3b8;\n  --text-muted: #64748b;\n  --text-link: #cbd5e1;\n  --text-bright: #ffffff;\n  \n  --brand-primary: #475569;\n  --brand-hover: #64748b;\n  --brand-active: #334155;\n  --brand-light: #94a3b8;\n  \n  --scrollbar-thumb: rgba(148, 163, 184, 0.15);\n  --input-bg: #10121a;\n  --input-border: transparent;\n  \n  --glass-bg: rgba(12, 14, 20, 0.95);\n  --glass-border: transparent;\n  \n  --gradient-brand: linear-gradient(135deg, #334155, #1e293b);\n  --gradient-dark: linear-gradient(to bottom, #0c0e14, #08090d);\n  box-shadow: none !important;\n}\n\n/* Cyberpunk Modern Modular Workspace (Farklı, Lüks ve Ergonomik Ada Mimarisi) */\n[data-theme=\"cyberpunk\"] .app {\n  background: #040507 !important;\n}\n\n[data-theme=\"cyberpunk\"] .app-container {\n  background: #040507 !important;\n  padding: 8px 10px 10px 0 !important;\n  gap: 8px !important;\n}\n\n[data-theme=\"cyberpunk\"] .server-list {\n  background: transparent !important;\n  padding-top: 8px !important;\n}\n\n[data-theme=\"cyberpunk\"] .channel-sidebar {\n  background: #0c0e14 !important;\n  border-radius: 18px !important;\n  overflow: hidden !important;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;\n}\n\n[data-theme=\"cyberpunk\"] .main-content {\n  background: #08090d !important;\n  border-radius: 18px !important;\n  overflow: hidden !important;\n  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.5) !important;\n}\n\n[data-theme=\"cyberpunk\"] .member-list-panel {\n  background: #0c0e14 !important;\n  border-radius: 18px !important;\n  margin-left: 8px !important;\n  overflow: hidden !important;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;\n}\n\n/* Cyberpunk Sıfır Çizgi & Dikişsiz Görünüm (Zero Lines / Seamless Panels) */\n[data-theme=\"cyberpunk\"] * {\n  border-color: transparent !important;\n}\n\n[data-theme=\"cyberpunk\"] .channel-sidebar,\n[data-theme=\"cyberpunk\"] .server-list,\n[data-theme=\"cyberpunk\"] .member-list-panel,\n[data-theme=\"cyberpunk\"] .member-list-header,\n[data-theme=\"cyberpunk\"] .chat-header,\n[data-theme=\"cyberpunk\"] .titlebar,\n[data-theme=\"cyberpunk\"] .title-bar,\n[data-theme=\"cyberpunk\"] .channel-footer,\n[data-theme=\"cyberpunk\"] .channel-header,\n[data-theme=\"cyberpunk\"] .user-panel,\n[data-theme=\"cyberpunk\"] .voice-connection-card,\n[data-theme=\"cyberpunk\"] .control-pill,\n[data-theme=\"cyberpunk\"] .message-actions-bar,\n[data-theme=\"cyberpunk\"] .message-input-area,\n[data-theme=\"cyberpunk\"] .message-input-control,\n[data-theme=\"cyberpunk\"] .channel-info-pill,\n[data-theme=\"cyberpunk\"] .discord-embed,\n[data-theme=\"cyberpunk\"] .user-profile-panel,\n[data-theme=\"cyberpunk\"] .settings-container,\n[data-theme=\"cyberpunk\"] .settings-sidebar,\n[data-theme=\"cyberpunk\"] .settings-content,\n[data-theme=\"cyberpunk\"] .message-reply-context,\n[data-theme=\"cyberpunk\"] .action-divider {\n  border: none !important;\n  border-left: none !important;\n  border-right: none !important;\n  border-top: none !important;\n  border-bottom: none !important;\n  outline: none !important;\n}\n\n[data-theme=\"cyberpunk\"] .action-divider {\n  display: none !important;\n}\n\n[data-theme=\"cyberpunk\"] .main-content::before,\n[data-theme=\"cyberpunk\"] .chat-header::after,\n[data-theme=\"cyberpunk\"] .channel-sidebar::after,\n[data-theme=\"cyberpunk\"] .app::before {\n  display: none !important;\n}\n\n/* Cyberpunk Aktif İkon ve Vurgular - Pembe/Mor Tamamen Sıfırlandı, Saf Titanyum Gri */\n[data-theme=\"cyberpunk\"] .server-icon {\n  border-radius: 16px !important;\n  border: none !important;\n}\n\n[data-theme=\"cyberpunk\"] .server-icon.active {\n  background-color: #1e293b !important;\n  color: #f8fafc !important;\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.5) !important;\n  border-radius: 16px !important;\n}\n\n[data-theme=\"cyberpunk\"] .server-icon.active .server-icon-inner {\n  background: #1e293b !important;\n  color: #f8fafc !important;\n  border-radius: 16px !important;\n}\n\n[data-theme=\"cyberpunk\"] .active-indicator {\n  background-color: #cbd5e1 !important;\n  box-shadow: 0 0 10px rgba(203, 213, 225, 0.4) !important;\n  border-radius: 4px !important;\n}\n\n[data-theme=\"cyberpunk\"] .channel-item {\n  border-radius: 10px !important;\n  margin: 3px 10px !important;\n  padding: 8px 14px !important;\n  border: none !important;\n  color: #94a3b8 !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n[data-theme=\"cyberpunk\"] .channel-item:hover {\n  background: rgba(255, 255, 255, 0.04) !important;\n  color: #f8fafc !important;\n}\n\n[data-theme=\"cyberpunk\"] .channel-item.selected {\n  background: rgba(255, 255, 255, 0.08) !important;\n  color: #ffffff !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25) !important;\n}\n\n[data-theme=\"cyberpunk\"] .channel-icon {\n  color: #64748b !important;\n  filter: none !important;\n  transition: color 0.2s ease !important;\n}\n\n[data-theme=\"cyberpunk\"] .channel-item:hover .channel-icon {\n  color: #94a3b8 !important;\n}\n\n[data-theme=\"cyberpunk\"] .channel-item.selected .channel-icon {\n  color: #cbd5e1 !important;\n}\n\n[data-theme=\"cyberpunk\"] .category-header,\n[data-theme=\"cyberpunk\"] .category-name {\n  color: #64748b !important;\n}\n\n/* Header & Search Bar */\n[data-theme=\"cyberpunk\"] .chat-header {\n  background: #08090d !important;\n}\n\n[data-theme=\"cyberpunk\"] .chat-header .channel-icon {\n  color: #94a3b8 !important;\n  filter: none !important;\n}\n\n[data-theme=\"cyberpunk\"] .channel-info-pill {\n  background: rgba(255, 255, 255, 0.03) !important;\n  border: none !important;\n}\n\n[data-theme=\"cyberpunk\"] .channel-info-pill:hover {\n  background: rgba(255, 255, 255, 0.06) !important;\n  border: none !important;\n}\n\n[data-theme=\"cyberpunk\"] .header-icon-btn,\n[data-theme=\"cyberpunk\"] .upload-btn,\n[data-theme=\"cyberpunk\"] .control-btn,\n[data-theme=\"cyberpunk\"] .control-btn.active,\n[data-theme=\"cyberpunk\"] .user-panel-btn {\n  color: #94a3b8 !important;\n  background: transparent !important;\n}\n\n[data-theme=\"cyberpunk\"] .header-icon-btn:hover,\n[data-theme=\"cyberpunk\"] .control-btn:hover,\n[data-theme=\"cyberpunk\"] .upload-btn:hover,\n[data-theme=\"cyberpunk\"] .user-panel-btn:hover {\n  color: #f8fafc !important;\n  background: rgba(255, 255, 255, 0.06) !important;\n}\n\n/* Mesaj Giriş Alanı - Yüzen Ada Tasarımı */\n[data-theme=\"cyberpunk\"] .message-input-area {\n  background: transparent !important;\n  padding: 0 20px 20px !important;\n}\n\n[data-theme=\"cyberpunk\"] .message-input-control {\n  background: #10121a !important;\n  border: none !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;\n  border-radius: 20px !important;\n  padding: 6px 14px !important;\n}\n\n[data-theme=\"cyberpunk\"] .message-input-control:focus-within {\n  border: none !important;\n  box-shadow: 0 10px 36px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.08) !important;\n}\n\n[data-theme=\"cyberpunk\"] .message-input-field {\n  color: #f8fafc !important;\n}\n\n[data-theme=\"cyberpunk\"] .send-btn {\n  background: #1e293b !important;\n  color: #cbd5e1 !important;\n  border: none !important;\n  border-radius: 12px !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;\n}\n\n[data-theme=\"cyberpunk\"] .send-btn:hover {\n  background: #334155 !important;\n  color: #ffffff !important;\n}\n\n/* Nötr Titanyum Avatar Harf Rozetleri (Mor/Pembe Yerine Mat Grafit Gri) */\n[data-theme=\"cyberpunk\"] .avatar-inner,\n[data-theme=\"cyberpunk\"] .avatar-initial,\n[data-theme=\"cyberpunk\"] .avatar-letter,\n[data-theme=\"cyberpunk\"] .avatar-placeholder-letter,\n[data-theme=\"cyberpunk\"] .preview-avatar-mock {\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%) !important;\n  color: #cbd5e1 !important;\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;\n  border-radius: 12px !important;\n  font-weight: 700 !important;\n}\n\n/* Üye Listesi & Rozetler */\n[data-theme=\"cyberpunk\"] .header-label {\n  color: #94a3b8 !important;\n}\n\n[data-theme=\"cyberpunk\"] .header-badge {\n  background: #334155 !important;\n  color: #f8fafc !important;\n  box-shadow: none !important;\n  border-radius: 8px !important;\n}\n\n[data-theme=\"cyberpunk\"] .member-item-professional:hover {\n  background: rgba(255, 255, 255, 0.04) !important;\n  border-radius: 10px !important;\n}\n\n/* TitleBar & Logo */\n[data-theme=\"cyberpunk\"] .titlebar {\n  background: #040507 !important;\n  border: none !important;\n}\n\n[data-theme=\"cyberpunk\"] .brand-status {\n  background: #334155 !important;\n  color: #cbd5e1 !important;\n}\n\n[data-theme=\"cyberpunk\"] .m-logo-img {\n  filter: none !important;\n}\n\n/* Mesajlar, Linkler ve Cevaplar */\n[data-theme=\"cyberpunk\"] .message-item:hover {\n  background: rgba(255, 255, 255, 0.02) !important;\n}\n\n[data-theme=\"cyberpunk\"] .message-author {\n  color: #f8fafc !important;\n}\n\n[data-theme=\"cyberpunk\"] .message-timestamp {\n  color: #64748b !important;\n}\n\n[data-theme=\"cyberpunk\"] .message-link-highlight {\n  color: #00a8fc !important;\n  background: transparent !important;\n  border-bottom: none !important;\n  text-decoration: none !important;\n}\n\n[data-theme=\"cyberpunk\"] .message-link-highlight:hover {\n  color: #00a8fc !important;\n  background: transparent !important;\n  text-decoration: underline !important;\n}\n\n[data-theme=\"cyberpunk\"] .message-reply-context {\n  background: rgba(255, 255, 255, 0.03) !important;\n  border: none !important;\n  border-left: 2px solid #475569 !important;\n  border-radius: 8px !important;\n}\n\n[data-theme=\"cyberpunk\"] .message-reply-accent {\n  background: #475569 !important;\n}\n\n/* Global Taşma Önleme & Modern Medya Kartları (Anti-Overflow & Sleek Embeds) */\n.discord-embed {\n  border: none !important;\n  border-left: none !important;\n  border-radius: 14px !important;\n  background: rgba(255, 255, 255, 0.03) !important;\n  backdrop-filter: blur(12px) !important;\n  padding: 12px 16px !important;\n  max-width: 520px !important;\n  overflow: hidden !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;\n}\n\n.embed-image,\n.attachment-image-wrapper img,\n.discord-embed-thumbnail img {\n  max-width: 100% !important;\n  max-height: 280px !important;\n  object-fit: contain !important;\n  border-radius: 10px !important;\n  background: #050608 !important;\n  display: block !important;\n  margin: 0 auto !important;\n}\n\n.message-body,\n.message-text,\n.embed-description,\n.embed-title {\n  word-break: break-word !important;\n  overflow-wrap: anywhere !important;\n}\n\n.embed-description a,\n.message-text a,\n.embed-author-name.link,\n.embed-title.link,\n.message-link-highlight {\n  word-break: break-all !important;\n  overflow-wrap: anywhere !important;\n  color: #00a8fc !important;\n  text-decoration: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.embed-description a:hover,\n.message-text a:hover,\n.embed-author-name.link:hover,\n.embed-title.link:hover,\n.message-link-highlight:hover {\n  text-decoration: underline !important;\n  color: #00a8fc !important;\n}\n\n/* Forest Green Theme */\n[data-theme=\"forest\"] {\n  --bg-primary: #0c1512;\n  --bg-secondary: #080f0c;\n  --bg-tertiary: #050a08;\n  --bg-modifier-hover: rgba(20, 184, 166, 0.08);\n  --bg-modifier-active: rgba(20, 184, 166, 0.15);\n  --bg-modifier-selected: rgba(15, 118, 110, 0.25);\n  --bg-floating: #101f1a;\n  \n  --text-primary: #f0f7f4;\n  --text-secondary: #8ca69e;\n  --text-muted: #526e64;\n  --text-link: #10b981;\n  \n  --brand-primary: #0f766e;\n  --brand-hover: #0d9488;\n  --brand-active: #115e59;\n  --brand-light: #14b8a6;\n  \n  --scrollbar-thumb: rgba(15, 118, 110, 0.3);\n  --input-bg: #0d1f1a;\n  --input-border: rgba(15, 118, 110, 0.2);\n  \n  --glass-bg: rgba(12, 21, 18, 0.85);\n  --glass-border: rgba(16, 185, 129, 0.08);\n  \n  --gradient-brand: linear-gradient(135deg, #0f766e, #115e59);\n}\n\n/* Light Theme */\n[data-theme=\"light\"] {\n  --bg-primary: #ffffff;\n  --bg-secondary: #f2f3f5;\n  --bg-tertiary: #e3e5e8;\n  --bg-modifier-hover: rgba(0, 0, 0, 0.05);\n  --bg-modifier-active: rgba(0, 0, 0, 0.1);\n  --bg-modifier-selected: rgba(88, 101, 242, 0.15);\n  --bg-floating: #ffffff;\n  \n  --text-primary: #060607;\n  --text-secondary: #4e5058;\n  --text-muted: #6d6f78;\n  --text-link: #0068e0;\n  --text-bright: #000000;\n  \n  --brand-primary: #5865f2;\n  --brand-hover: #4752c4;\n  --brand-active: #3c45a5;\n  --brand-light: #5865f2;\n  \n  --scrollbar-thumb: rgba(88, 101, 242, 0.2);\n  --input-bg: #e3e5e8;\n  --input-border: rgba(0,0,0,0.1);\n  \n  --glass-bg: rgba(242, 243, 245, 0.9);\n  --glass-border: rgba(0, 0, 0, 0.08);\n  \n  --gradient-brand: linear-gradient(135deg, #5865f2, #4752c4);\n}\n\n/* Amber Gold / Sarı & Siyah Tema - Mat Siyah ve Amber Sarısı Vurgular */\n[data-theme=\"amber-gold\"] {\n  --bg-primary: #0a0b0e;\n  --bg-secondary: #0f1117;\n  --bg-tertiary: #060709;\n  --bg-modifier-hover: rgba(245, 158, 11, 0.08);\n  --bg-modifier-active: rgba(245, 158, 11, 0.14);\n  --bg-modifier-selected: rgba(245, 158, 11, 0.2);\n  --bg-floating: #14161f;\n  \n  --text-primary: #fef3c7;\n  --text-secondary: #cbd5e1;\n  --text-muted: #78716c;\n  --text-link: #f59e0b;\n  --text-bright: #ffffff;\n  \n  --brand-primary: #f59e0b;\n  --brand-hover: #fbbf24;\n  --brand-active: #d97706;\n  --brand-light: #fef08a;\n  \n  --scrollbar-thumb: rgba(245, 158, 11, 0.25);\n  --input-bg: #14161f;\n  --input-border: rgba(245, 158, 11, 0.2);\n  \n  --glass-bg: rgba(15, 17, 23, 0.92);\n  --glass-border: rgba(245, 158, 11, 0.1);\n  \n  --gradient-brand: linear-gradient(135deg, #f59e0b, #d97706);\n}\n\n/* Monochrome Noir / Siyah & Beyaz Tema - Ultra Sade, Çizgisiz Saf Kontrast */\n[data-theme=\"monochrome-noir\"] {\n  --bg-primary: #000000;\n  --bg-secondary: #0a0a0a;\n  --bg-tertiary: #050505;\n  --bg-modifier-hover: rgba(255, 255, 255, 0.06);\n  --bg-modifier-active: rgba(255, 255, 255, 0.12);\n  --bg-modifier-selected: rgba(255, 255, 255, 0.18);\n  --bg-floating: #121212;\n  \n  --text-primary: #ffffff;\n  --text-secondary: #a1a1aa;\n  --text-muted: #52525b;\n  --text-link: #f4f4f5;\n  --text-bright: #ffffff;\n  \n  --brand-primary: #ffffff;\n  --brand-hover: #e4e4e7;\n  --brand-active: #d4d4d8;\n  --brand-light: #ffffff;\n  \n  --scrollbar-thumb: rgba(255, 255, 255, 0.15);\n  --input-bg: #121212;\n  --input-border: rgba(255, 255, 255, 0.15);\n  \n  --glass-bg: rgba(10, 10, 10, 0.95);\n  --glass-border: rgba(255, 255, 255, 0.08);\n  \n  --gradient-brand: linear-gradient(135deg, #27272a, #09090b);\n}\n\n/* Sarı & Beyaz / Warm Ivory Tema - Sıcak Kum ve Bal Rengi Vurgular */\n[data-theme=\"yellow-white\"] {\n  --bg-primary: #fafaf7;\n  --bg-secondary: #f4f3ed;\n  --bg-tertiary: #e8e6dc;\n  --bg-modifier-hover: rgba(217, 119, 6, 0.08);\n  --bg-modifier-active: rgba(217, 119, 6, 0.14);\n  --bg-modifier-selected: rgba(217, 119, 6, 0.18);\n  --bg-floating: #ffffff;\n  \n  --text-primary: #1c1917;\n  --text-secondary: #57534e;\n  --text-muted: #78716c;\n  --text-link: #d97706;\n  --text-bright: #0c0a09;\n  \n  --brand-primary: #d97706;\n  --brand-hover: #b45309;\n  --brand-active: #92400e;\n  --brand-light: #f59e0b;\n  \n  --scrollbar-thumb: rgba(217, 119, 6, 0.25);\n  --input-bg: #ffffff;\n  --input-border: rgba(217, 119, 6, 0.25);\n  \n  --glass-bg: rgba(250, 250, 247, 0.94);\n  --glass-border: rgba(217, 119, 6, 0.12);\n  \n  --gradient-brand: linear-gradient(135deg, #d97706, #b45309);\n}\n\n\n/* --- ELECTRON FIXES --- */\ninput, textarea, select, button {\n  -webkit-app-region: no-drag !important;\n  -webkit-user-select: text !important;\n  user-select: text !important;\n}\n\nbody {\n  -webkit-user-select: auto !important;\n  user-select: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
